"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MechventController = function MechventController($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, User, Constants, CONST, materialButtons, datePicker, $rootScope, $location, FunctionService, dateTimeHelper) {
  _classCallCheck(this, MechventController);

  this.datatableApi;
  this.user = User.getUser();
  this.name = "Mechanical Ventilation Hours";
  this.episodeValue = "";
  this.fixedValue = "";
  this.specialtyString = "";
  this.separationString = "";
  this.locale = "en-au";
  $scope.dateTimeHelper = dateTimeHelper;
  this.url = WEBSERVICEURL + "/dataagility/api/service.episodeaudit?removeCoding=1&removeVent=1&";
  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.fixedValue = $scope.vm.episodeValue === "$" ? 2 : 4;
    $scope.vm.functionSettings = response.functionSettings;

    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
        return x.mData === "drgVersion";
      });
      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
    }

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
      filterCampus($scope.vm.campusOptions);
    });

    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;

    if ($scope.vm.functionSettings.MechanicalVentReportCodingStatusColumn && $scope.vm.functionSettings.MechanicalVentReportCodingStatusColumn.isActive) {
      $scope.vm.dtColumns.push(DTColumnBuilder.newColumn("codingStatus").withTitle("Coding Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"));
    }

    if ($scope.vm.functionSettings.MechanicalVentReportHealthFundColumn && $scope.vm.functionSettings.MechanicalVentReportHealthFundColumn.isActive) {
      $scope.vm.dtColumns.push(DTColumnBuilder.newColumn("healthCareFund").withTitle("Health Fund").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"));
    }
  });

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // tell DataTables we're using Aussie-formatted dates for ordering
    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    },
    url: $scope.vm.initUrl,
    type: "GET",
    error: function error(xhr, _error, thrown) {
      if (thrown == "Unauthorized") window.location.replace(window.location.origin + "/login");
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]).withColumnFilter({
    //sPlaceHolder: "head:after",
    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }]
  });

  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("PCCLModifiedUser").withTitle("Coder Name").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("ICUHours").withTitle("ICU Hours").withOption("defaultContent", "0").withOption('type', 'any-number').withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return $scope.dateTimeHelper.convertICUHours(data);
  }), DTColumnBuilder.newColumn("mechVenitilationHours").withTitle("MV Hours").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("NIVentilationHours").withTitle("NIV Hours").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG<br>Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drg").withTitle("Original DRG").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentDRG").withTitle("Final DRG").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("wies").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return parseFloat(data).toFixed($scope.vm.fixedValue);
  }), DTColumnBuilder.newColumn("finalWIES").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    if (typeof data !== "undefined") {
      return parseFloat(data).toFixed($scope.vm.fixedValue);
    } else {
      return parseFloat("0").toFixed($scope.vm.fixedValue);
    }
  }), DTColumnBuilder.newColumn("totalWIESChange").withTitle("Loading...").withOption("defaultContent", "0").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return parseFloat(data).toFixed($scope.vm.fixedValue);
  })];

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];

  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = {};

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty($scope.vm.specialtyOptions);
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "days"),
      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
    }
  };

  // callbacks for lx-selects and lx-date-picker
  datePicker.autoClose($scope);
  this.specialtyCallback = specialtyCallback;

  function setDtHeaders(table) {
    var dischargeDateColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === "dischargeDate";
    });
    var indexOfDischargeDateColumn = $scope.vm.dtColumns.indexOf(dischargeDateColumn[0]);
    $(table.column(indexOfDischargeDateColumn).header()).html($scope.vm.separationString + " Date");

    var specialityColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === "speciality";
    });
    var indexOfSpecialityColumn = $scope.vm.dtColumns.indexOf(specialityColumn[0]);
    $(table.column(indexOfSpecialityColumn).header()).html($scope.vm.specialtyString);

    var wiesColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === "wies";
    });
    var indexOfWiesColumn = $scope.vm.dtColumns.indexOf(wiesColumn[0]);
    $(table.column(indexOfWiesColumn).header()).html("Original " + $scope.vm.episodeValue);

    var finalWIESColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === "finalWIES";
    });
    var indexOfFinalWIESColumn = $scope.vm.dtColumns.indexOf(finalWIESColumn[0]);
    $(table.column(indexOfFinalWIESColumn).header()).html("Final " + $scope.vm.episodeValue);

    var totalWIESChangeColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === "totalWIESChange";
    });
    var indexOfTotalWIESChangeColumn = $scope.vm.dtColumns.indexOf(totalWIESChangeColumn[0]);
    $(table.column(indexOfTotalWIESChangeColumn).header()).html($scope.vm.episodeValue + " Difference");
  }

  function specialtyCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === "add") {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  this.changeData = changeData;

  function changeData() {
    var campus = "";
    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }

    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&campus=" + checkParam(campus);
    if ($scope.vm.datatableApi) {
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    }
  }

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    var clearAuditTable = auditTable.search("").draw();

    filterCampus("minus");
    filterSpecialty("minus");

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.vm.changeData();
    });
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case "campus":
        if (thisModifier === "add") {
          filterCampus("add");
        } else {
          filterCampus("minus");
        }

        break;

      case "specialty":
        if (thisModifier === "add") {
          filterSpecialty("add");
        } else {
          filterSpecialty("minus");
        }

        break;

      default:
        break;
    }
  }
};

exports.default = MechventController;


// WEBPACK FOOTER //
// ./client/app/common/reports/mechvent/mechvent.controller.js